module.exports = __webpack_public_path__ + "img/forest-conservation.1b88a5a6.png";